import MessageApi from '../../../../api/inbox/message';

export default {
  async hideComment(_, { conversationId, messageId }) {
    try {
      const response = await MessageApi.hideMessage(conversationId, messageId);
      return response;
    } catch (error) {
      // Ignore error
      return { data: { success: false } };
    }
  },
  async autoReplyComment(_, { conversationId, messageId }) {
    try {
      const response = await MessageApi.autoReplyMessage(
        conversationId,
        messageId
      );
      return response;
    } catch (error) {
      // Ignore error
      return { data: { success: false } };
    }
  },
  async blockUser(_, { conversationId, messageId }) {
    return MessageApi.blockUser(conversationId, messageId);
  },
};
